import React, {
    useCallback,
    useContext,
    useEffect,
    useMemo,
    useState,
} from "react";
import { useTranslation } from "react-i18next";
import userContext from "../../../context/user-context";
import Get from "../../Utils/API/Get";
import DateFormated from "../../Utils/Date/Date";
import Export from "../../Utils/XLS/Export";
import InvoiceTable from "../Table/InvoiceTable";
import Sorter from "../../UI/Toolbar/Sorter";
import Currency from "../../Utils/Number/Currency";
import {fireGTMDownloadFileEvent} from "../../Utils/GTM/GTMHelper";
import axios from "axios";
import {
    TODAY,
    TODAY_MINUS_14,
    TODAY_MINUS_30,
    DEFAULT_FILTER_ALL_PAGE_NUMBER,
    DEFAULT_FILTER_ALL_PAGE_SIZE
} from "../../Accounts/Account/Tables/DateFilters";
import formatDate from "../../Utils/Date/formatDate";
import transactions from "../../Accounts/Account/Transactions/Transactions";

const getPayments = async ({ startDate, endDate, pageNumber, pageSize}) => {
    let queryJson = {};
    if (pageNumber && pageSize) {
        queryJson = {
            pageNumber,
            pageSize
        };
    } else {
        queryJson = {
            startDate,
            endDate,
        };
    }

    try {
        const payments = await Get({
            endpoint: "/accounts/paymentHeaders",
            queryJson,
        });
        if (!payments) return false;
        return payments;
    } catch (e) {
        console.error(e.message);
        return false;
    }
};

const filterMinStartDate = (payments) => {
    return new Date(Math.min(...payments.map(e => new Date(e.date))));
}

const getPaymentLines = async ({ startDate, endDate, accountCode, pageNumber, pageSize}) => {
    let queryJson = {};

    if (pageNumber && pageSize) {
        queryJson = {
            // accountCode,
            startDate,
            endDate,
            pageNumber,
            pageSize,
        };
    } else {
        queryJson = {
            // accountCode,
            startDate,
            endDate,
        };
    }
    try {
        const transactions = await Get({
            endpoint: "/accounts/paymentLines",
            queryJson,
        });
        if (!transactions) return false;
        return transactions;
    } catch (e) {
        console.error(e.message);
        return false;
    }
};
const mapPayment = (payment) => {
    return {
        ...payment,
        checkBox: payment.paymentNumber + "_" + payment.paymentReference,
    };
};

const Payments = (props) => {
    const fetchIdRef = React.useRef(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const { user } = useContext(userContext);
    const { t, i18n } = useTranslation();
    const [payments, setPayments] = useState([]);
    const [pages, setPages] = useState(0);
    const [loading, setLoading] = useState(true);


    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [pageNumber, setPageNumber] = useState(DEFAULT_FILTER_ALL_PAGE_NUMBER);
    const [pageSize, setPageSize] = useState(DEFAULT_FILTER_ALL_PAGE_SIZE);

    const [isSpecific, setIsSpecific] = useState(false);
    const [dateFilterType, setDateFilterType] = useState('last_all');

    const [isSelectAll, setIsSelectAll] = useState(false);
    const [accountTypes, setAccountTypes] = useState([]);
    const [accountType, setAccountType] = useState();
	const [searchData, setSearchData] = useState([]);

    /* START DATEFILTERS FUNCTIONS */
    const dateFilterSetStartDate = (date) => {
        if (date != null) {
            const dateFormatted = `${date.toISOString().split("T")[0]}T00:00:00.000Z`;
            setStartDate(dateFormatted)
        }
    }
    const dateFilterSetEndDate = (date) => {
        if(date != null){
            const dateFormatted = `${date.toISOString().split("T")[0]}T23:59:59.999Z`;
            setEndDate(dateFormatted)
        }
    }
    const setLastAll = (refresh = true, component = null) => {
        setStartDate(null);
        setEndDate(null);
        setPageNumber(DEFAULT_FILTER_ALL_PAGE_NUMBER);
        setPageSize(DEFAULT_FILTER_ALL_PAGE_SIZE);
        setIsSpecific(false);

    }
    const setLast14Days = (refresh = true, component = null) => {
        setStartDate(formatDate(new Date(TODAY_MINUS_14)));
        setEndDate(formatDate(TODAY,'23:59:59.999Z'));
        setPageNumber(null);
        setPageSize(null);
        setIsSpecific(false);
    }
    const setLast30Days = () => {
        setStartDate(formatDate(new Date(TODAY_MINUS_30)));
        setEndDate(formatDate(TODAY,'23:59:59.999Z'));
        setPageNumber(null);
        setPageSize(null);
        setIsSpecific(false);
    }
    const setSpecificDate = () => {
        setStartDate(null);
        setEndDate(null);
        setPageNumber(null);
        setPageSize(null);
        setIsSpecific(true);
    }
    const dateFilterSetDateFilterType = (type) => {
        setDateFilterType(type)
        switch (type) {
            case 'last_all': setLastAll(); break;
            case 'last_14': setLast14Days(); break;
            case 'last_30': setLast30Days(); break;
            case 'specific_date': setSpecificDate(); break;
            default: setLastAll();
        }
    }
    /* END DATEFILTERS FUNCTIONS */



    /*const fetchData = useCallback(
      async ({ pageSize, pageIndex }) => {
        const fetchId = ++fetchIdRef.current;
        setLoading(true);
        if (user && user.accountCode) {
          const payments = await getPayments({
            accountCode: user.accountCode,
            pageSize,
            pageNumber: pageIndex + 1,
          });
          if (fetchId === fetchIdRef.current) {
            const mappedPayments = payments.data.map(mapInvoice);
            setPayments(mappedPayments);
            setPages(payments.totalPages);
            setLoading(false);
            setTotalRecords(payments.totalRecords);
          }
        }
      },
      [user]
    );*/
    useEffect(() => {
        if(isSpecific && (startDate === null || endDate === null)){
            return null;
        }else{
            setLoading(true);
        }

        user &&
            getPayments({
                startDate:startDate,
                endDate:endDate,
                pageNumber: pageNumber,
                pageSize: pageSize
            }).then((payments) => {
                const mappedPayments = payments.data.map((payment) =>
                    mapPayment(payment)
                );
                setPayments(mappedPayments);
                setPages(payments.totalPages);
                setLoading(false);
                setTotalRecords(payments.totalRecords);
            });
    }, [user, startDate, endDate,dateFilterType,pageNumber,pageSize ]);



    useEffect(
        () =>
            isSelectAll
                ? setChecked(
                      searchData.map(
                          (payment) =>
                              payment.paymentNumber +
                              "_" +
                              payment.paymentReference
                      )
                  )
                : setChecked([]),
        [isSelectAll]
    );
    const [checked, setChecked] = useState([]);
    const handleCheck = (isChecked, value) => {
        if (isChecked && !checked.includes(value)) {
            setChecked((checked) => [
                ...checked.filter((thisChecked) => thisChecked !== value),
                value,
            ]);
        } else {
            setChecked((checked) =>
                checked.filter((thisChecked) => thisChecked !== value)
            );
        }
    };

    let sorter = null;
    const setSorterRef = element => sorter = element;
    const storeSortedItems = (items) => { return setPayments(items); }

    const columns = useMemo(
        () => [
            {
                Header: (
                    <div className="form-check flex flex-row justify-content-end align-items-end">
                        <input
                            type="checkbox"
                            id="select_all"
                            className="form-check-input"
                            value={isSelectAll}
                            onChange={(v) => setIsSelectAll(v.target.checked)}
                        ></input>
                    </div>
                ),
                accessor: "checkBox",
                Cell: (props) => {
                    return (
                        <div className="form-check flex flex-row justify-content-end">
                            <input
                                type="checkbox"
                                value={props.value}
                                className="form-check-input"
                                onChange={(v) => {
                                    handleCheck(
                                        v.target.checked,
                                        v.target.value
                                    );
                                }}
                                checked={!!checked.includes(props.value)}
                            ></input>
                        </div>
                    );
                },
                disableSortBy: true,
            },
            {
                Header: t("docs.payments.table.headers.accountCode"),
                accessor: "accountCode",
                Cell: (props) => {
                    return (
                        <div className="flex flex-column justify-left">
                            <strong>{props.value}</strong>
                        </div>
                    );
                },
                sortMethod: (a, b) => {
                    if (a < b) return 1;
                    else if (a > b) return -1;
                    else return 0;
                },
            },
            {
                Header: t("docs.payments.table.headers.paymentStatus"),
                id: "status",
                accessor:
                    i18n.language === "fr"
                        ? "paymentStatus.descriptionFr"
                        : "paymentStatus.descriptionEn",
                Cell: (props) => {
                    return <span>{props.value}</span>;
                },
            },
            {
                id: "paymentDate",
                Header: t("docs.payments.table.headers.paymentDate"),
                accessor: "paymentDate",
                sort: "desc",
                Cell: (props) => {
                    return <DateFormated date={props.value} withTime={false} />;
                },
                sortMethod: (a, b) => {
                    var a1 = new Date(a).getTime();
                    var b1 = new Date(b).getTime();
                    if (a1 < b1) return 1;
                    else if (a1 > b1) return -1;
                    else return 0;
                },
            },
            {
                Header: t("docs.payments.table.headers.paymentNumber"),
                accessor: "paymentNumber",
                Cell: (props) => {
                    return <span>{props.value}</span>;
                },
                sortMethod: (a, b) => {
                    if (a < b) return 1;
                    else if (a > b) return -1;
                    else return 0;
                },
            },
            {
                Header: t("docs.payments.table.headers.paymentAmount"),
                accessor: "paymentAmount",
                Cell: (props) => {
                    return (
                        // <span className="amount-price">
                        //     {formatter.format(props.value)}
                        // </span>
                        <span className="amount-price">
                            <Currency value={props.value.toFixed(2)}  />
                        </span>
                    );
                },
            },
            {
                Header: t("docs.payments.table.headers.paymentReference"),
                accessor: "paymentReference",
                Cell: (props) => {
                    return <span>{props.value}</span>;
                },
                sortMethod: (a, b) => {
                    if (a < b) return 1;
                    else if (a > b) return -1;
                    else return 0;
                },
            },
            {
                Header: t("docs.payments.table.headers.paymentMode"),
                id: "paymentMode",
                accessor:
                    i18n.language === "fr"
                        ? "paymentMode.descriptionFr"
                        : "paymentMode.descriptionEn",
                Cell: (props) => {
                    return <span>{props.value}</span>;
                },
            },
        ],
        [t, i18n, checked]
    );

    const doXLSExport = useCallback((fileType) => {
        const checkedPayments = payments
            .filter((payment) =>
                checked.includes(
                    payment.paymentNumber + "_" + payment.paymentReference
                )
            )
            .map((payment) => ({
                [t("export.payments.paymentDate")]: new Date(payment.paymentDate.split('T')[0]),
                [t("export.payments.paymentNumber")]: payment.paymentNumber,
                [t("export.payments.paymentAmount")]: payment.paymentAmount,
                [t("export.payments.paymentReference")]:
                    payment.paymentReference,
                [t("export.payments.paymentMode")]:
                    i18n.language === "fr"
                        ? payment.paymentMode.descriptionFr
                        : payment.paymentMode.descriptionEn,
                /*        accountCode: payment.accountCode,
        invoiceDate: payment.invoiceDate,
        invoicePaid: payment.invoicePaid,
        invoicePaidAmount: payment.invoicePaidAmount,
        invoiceReference: payment.invoiceReference,
        isInvoiceImputed: payment.isInvoiceImputed,
        shippedToSubAccountCode: payment.shippedToSubAccountCode,*/
            }));
        Export(checkedPayments, "payments", [t("export.payments.paymentAmount")], fileType);
        fireGTMDownloadFileEvent('paiement', `${fileType} - Sommaire`);
    }, [checked, payments]);

    const doXLSDetailExport = useCallback(async (fileType) => {
        console.log(payments)
        console.log(payments.accountCode)
        try {
            const paymentLines = await getPaymentLines({
                startDate: (pageNumber && pageSize) ? formatDate(filterMinStartDate(payments)) : `${startDate.split("T")[0]}T00:00:00.000Z`,
                endDate: (pageNumber && pageSize) ? formatDate(TODAY,'23:59:59.999Z') : `${endDate.split("T")[0]}T23:59:59.999Z`,
                accountCode: payments.accountCode,
                pageNumber,
                pageSize
            });
            const checkedPayments = paymentLines.data
                .filter((payment) =>
                    checked.includes(
                        payment.paymentNumber + "_" + payment.paymentReference
                    )
                )
                .map((payment) => ({
                    [t("export.payments.paymentDate")]: new Date(payment.paymentDate.split('T')[0]),
                    [t("export.payments.paymentNumber")]: payment.paymentNumber,
                    [t("export.payments.paymentAmountDetail")]: payment.paymentAmount,
                    [t("export.payments.paymentReference")]:
                        payment.paymentReference,
                    [t("export.payments.paymentMode")]:
                        i18n.language === "fr"
                            ? payment.paymentMode.descriptionFr
                            : payment.paymentMode.descriptionEn,
                    [t("export.payments.invoicePaid")]: payment.invoicePaid,
                    [t("export.payments.invoiceType.label")]:
                        payment.isInvoiceImputed
                            ? t("export.payments.invoiceType.invoice")
                            : t("export.payments.invoiceType.not_imputed"),
                    [t("export.payments.invoicePaidAmount")]:
                        payment.invoicePaidAmount,
                    [t("export.payments.invoiceReference")]:
                        payment.invoiceReference,
                    [t("export.payments.invoiceDate")]:
                        payment.invoiceDate
                            ? new Date(payment.invoiceDate.split('T')[0])
                            : null,
                    [t("export.payments.invoiceDueDate")]:
                        payment.invoiceDueDate
                            ? new Date(payment.invoiceDueDate.split('T')[0])
                            : null,
                    [t("export.payments.shippedToSubAccountCode")]:
                        payment.shippedToSubAccountCode,
                }));
            Export(checkedPayments, "payments", [t("export.payments.invoicePaidAmount")], fileType);
            fireGTMDownloadFileEvent('paiement', `${fileType} - Detaille`);
        } catch (e) {}
    }, [checked, payments]);

    const doPDFExport = useCallback(async () => {
        const checkedPaymentsPDF = payments
            .filter((payment) =>
                checked.includes(payment.checkBox.toString())
            );
        let filesPathString = "";
        checkedPaymentsPDF.map((item, index) => {
            if(item.documentPath !== ""){
                filesPathString += (item.documentPath);
                if((checkedPaymentsPDF.length > 1 ) && index !== checkedPaymentsPDF.length-1){ filesPathString += ","; }
            }
        });
        await(axios.get(`mergepdf?filenames=`+filesPathString)
            .then(response => {
                download('Payments.pdf', response.data);

            }).catch(error => { console.log(error.message); }));

    }, [checked]);

    function download(filename, text) {
        var element = document.createElement('a');
        element.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(text));
        element.setAttribute('download', filename);

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    }

    let sorterValues = [
        {
            label: t("docs.payments.table.headers.paymentDate"),
            id: 'paymentDate',
            value: 'paymentDate',
            type: 'date'
        },{
            label: t("docs.payments.table.headers.accountCode"),
            id: 'accountCode',
            value: 'accountCode',
            type: 'int'
        },{
            label: t("docs.payments.table.headers.paymentNumber"),
            id: 'paymentNumber',
            value: 'paymentNumber',
            type: 'int'
        },{
            label: t("docs.payments.table.headers.paymentAmount"),
            id: 'paymentAmount',
            value: '-paymentAmount',
            type: 'float'
        },{
            label: t("docs.payments.table.headers.paymentReference"),
            id: 'paymentReference',
            value: 'paymentReference',
            type: 'int'
        },{
            label: t("docs.payments.table.headers.paymentMode"),
            id: 'paymentMode',
            value: (i18n.language === "fr") ? "paymentMode.descriptionFr" : "paymentMode.descriptionEn",
            type: 'string'
        },
    ];
    return (
        <div className="documents">
            <div className="container container--larger flex nopadding">
                <h2 className="headline headline--section">
                    {t("docs.payments.title")}
                </h2>
                <div className="row">
                    <div className="col-12"></div>
                </div>
            </div>
            <InvoiceTable
                columns={columns}
                data={payments}
                //fetchData={fetchData}
                checked={checked}
                pageCount={pages}
                totalRecords={totalRecords}
                loading={loading}
                doXLSExport={doXLSExport}
                doXLSDetailExport={doXLSDetailExport}
                doPDFExport={doPDFExport}
                startDate={startDate}
                setStartDate={dateFilterSetStartDate}
                endDate={endDate}
                setEndDate={dateFilterSetEndDate}
                accountTypes={accountTypes}
                accountType={accountType}
                setAccountType={setAccountType}
                getSortedItems={storeSortedItems}
                sorterValues={sorterValues}
                showExportPdf={true}
                showExportXml={true}
                setDateFilterType={dateFilterSetDateFilterType}
                dateFilterType={dateFilterType}
                initialSortField='paymentDate'
                labelFilterAll={t("docs.invoices.table.filter.all.payments")}
				searchData={searchData}
				setSearchData={setSearchData}
            />
        </div>
    );
};

export default Payments;
